module.exports = __webpack_public_path__ + "img/vegetable-potatoes-350x184.7696098a.jpg";